var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90444 5.16798L4.76158 5.16798C3.13058 5.16798 1.83301 6.4492 1.83301 7.99973C1.83301 9.33633 2.79533 10.4713 4.10734 10.7606C4.31721 10.8069 4.53612 10.8315 4.76158 10.8315C5.03772 10.8315 5.26158 11.0553 5.26158 11.3315C5.26158 11.6076 5.03772 11.8315 4.76158 11.8315C4.46331 11.8315 4.17221 11.799 3.89201 11.7372C2.15032 11.3531 0.833008 9.83434 0.833008 7.99973C0.833008 5.87011 2.60549 4.16798 4.76158 4.16798L5.90444 4.16798C8.06726 4.16798 9.83301 6.06519 9.83301 7.99973C9.83301 8.27587 9.60915 8.49973 9.33301 8.49973C9.05687 8.49973 8.83301 8.27587 8.83301 7.99973C8.83301 6.61196 7.50947 5.16798 5.90444 5.16798Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.207 10.7713C13.0214 10.5668 13.0368 10.2506 13.2413 10.0651C13.8132 9.54601 14.1663 8.81171 14.1663 7.99972C14.1663 6.66312 13.204 5.5281 11.892 5.2388C11.6821 5.19252 11.4632 5.16797 11.2378 5.16797C10.9616 5.16797 10.7378 4.94411 10.7378 4.66797C10.7378 4.39183 10.9616 4.16797 11.2378 4.16797C11.536 4.16797 11.8271 4.20047 12.1073 4.26226C13.849 4.64631 15.1663 6.1651 15.1663 7.99972C15.1663 9.11031 14.6816 10.1084 13.9132 10.8056C13.7088 10.9912 13.3925 10.9758 13.207 10.7713Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5951 11.3315C10.5951 11.6076 10.3712 11.8315 10.0951 11.8315C7.93223 11.8315 6.16648 9.93425 6.16648 7.99972C6.16648 7.72357 6.39034 7.49972 6.66648 7.49972C6.94262 7.49972 7.16648 7.72357 7.16648 7.99972C7.16648 9.38748 8.49002 10.8315 10.0951 10.8315C10.3712 10.8315 10.5951 11.0553 10.5951 11.3315Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6461 11.6478C11.8414 11.4525 12.158 11.4525 12.3532 11.6478L13.4139 12.7084L14.4745 11.6478C14.6698 11.4525 14.9864 11.4525 15.1817 11.6478C15.3769 11.843 15.3769 12.1596 15.1817 12.3549L14.121 13.4155L15.1817 14.4762C15.3769 14.6714 15.3769 14.988 15.1817 15.1833C14.9864 15.3786 14.6698 15.3786 14.4745 15.1833L13.4139 14.1226L12.3532 15.1833C12.158 15.3786 11.8414 15.3786 11.6461 15.1833C11.4509 14.988 11.4509 14.6714 11.6461 14.4762L12.7068 13.4155L11.6461 12.3549C11.4509 12.1596 11.4509 11.843 11.6461 11.6478Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLink);
export default __webpack_public_path__ + "static/media/no-link.ef615eb7bb7a4ea6c8a3fa270ea4c432.svg";
export { ForwardRef as ReactComponent };